import { COLOR } from "../../themes"

export const getStyleReactModal = (width, borderRadius) => {
  return {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: COLOR.BACKDROP,
      margin: 0,
      padding: 0,
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 50,
    },
    content: {
      position: 'absolute',
      inset: 'auto',
      width,
      height: 'auto',
      backgroundColor: COLOR.WHITE,
      overflow: 'auto',
      borderRadius: borderRadius || '4px',
      outline: 'none',
      padding: 0,
    }
  }
}
